jQuery(function ($) {
  function initSaleTimers() {
    $(".js-summit-sale-timer").each(function () {
      const $timer = $(this);

      if ($timer.data("timerInitialized")) return;
      $timer.data("timerInitialized", true);

      const endTimestamp = parseInt($timer.attr("data-sale-ends"), 10);

      if (!endTimestamp) return;

      const $days = $timer.find(".js-time-days");
      const $hours = $timer.find(".js-time-hours");
      const $minutes = $timer.find(".js-time-minutes");
      const $seconds = $timer.find(".js-time-seconds");

      function pad(num) {
        return String(num).padStart(2, "0");
      }

      function updateTimer() {
        const now = Math.floor(Date.now() / 1000);
        let diff = endTimestamp - now;

        if (diff <= 0) {
          $timer.addClass("is-expired");
          $timer.html(`
            <div class="hero-sale-timer__expired">
              <span class="hero-sale-timer__expired-label">Offer expired</span>
            </div>
          `);
          clearInterval(interval);
          return;
        }

        const days = Math.floor(diff / 86400);
        diff -= days * 86400;

        const hours = Math.floor(diff / 3600);
        diff -= hours * 3600;

        const minutes = Math.floor(diff / 60);
        const seconds = diff - minutes * 60;

        $days.text(pad(days));
        $hours.text(pad(hours));
        $minutes.text(pad(minutes));
        $seconds.text(pad(seconds));
      }

      updateTimer();
      const interval = setInterval(updateTimer, 1000);
    });
  }

  initSaleTimers();
  setTimeout(initSaleTimers, 300);
  setTimeout(initSaleTimers, 1000);
});
